import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutDaviplataVoucherContainerComponent } from './components/checkout-daviplata-voucher-container/checkout-daviplata-voucher-container.component';

@Component({
  selector: 'angular-monorepo-voucher',
  standalone: true,
  imports: [CommonModule, CheckoutDaviplataVoucherContainerComponent],
  templateUrl: './voucher.component.html',
  styleUrl: './voucher.component.scss',
})
export class VoucherComponent {}
